const $ = jQuery.noConflict();

// ASANA ANIMATION-LIKE FUNCTIONS
// function checkOpenLinkPosition(targetThis) {
// 	const currentItem = $('.main-header__nav > .menu > li.open-link');
// 	const clickedItem = $(targetThis).closest('li');
// 	let currentIndex, clickedIndex;

// 	if (currentItem.length) {
// 		currentIndex = currentItem.index();
// 		clickedIndex = clickedItem.closest('li').index();
		
// 		if (clickedIndex < currentIndex) {
// 			animateMenuItems(clickedItem, "right");
// 		} else if (clickedIndex > currentIndex) {
// 			animateMenuItems(clickedItem, "left");
// 		}
// 	}
// }

// function animateMenuItems(item, direction) {
//   const itemsToAnimate = item.closest('li').find('.mega-menu-wrapper').find('[class*="col-"]');
//   const delayStep = 100; // Delay between each item animation in milliseconds

//   itemsToAnimate.each((index, element) => {
//     const delay = index * delayStep; // Calculate the delay for this item
//     const $element = $(element);

//     if (direction === "left") {
//       $element.css("left", "-40px");
//       setTimeout(() => {
//         $element.animate({ left: "0" }, 500);
//       }, delay);
//     } else if (direction === "right") {
//       $element.css("left", "40px");
//       setTimeout(() => {
//         $element.animate({ left: "0" }, 500);
//       }, delay);
//     }
//   });
// }

class MegaMenu {
	constructor() {
		this.menu = $('.main-header__nav');
		this.menuItems = this.menu.find('> .menu > .menu-item-object-ccs_custom_menu_item');
		this.menuItemsLinks = this.menuItems.find('> a');
		this.searchItem = $('.btn-search');
		this.hamburgerItem = $('.btn-hamburger');
		this.nextStepItem = $('.next-step-btn > .menu a');
		this.blockCardImages = $('.main-header .block-card-image .image-wrapper');
	}

	static closeAllMegaMenus() {
		$('.main-header .main-header__nav').removeClass('open');
		$('.main-header .main-header__nav .menu-item').removeClass('open-link');
		$('.main-header .main-header__nav .menu-item a').next().removeClass('active');
		$('.main-header .mega-menu-background').removeClass('active');
		$('body').removeClass('lock-scroll overlayed');
	}
	static closeSearch() {
		$('.main-header .search-wrapper').removeClass('active');
		$('.main-header .btn-search').removeClass('open');
		$('.main-header .mega-menu-background').removeClass('active');
		$('body').removeClass('search_bar_active lock-scroll overlayed');
	}
	static closeHamburger() {
		$('.main-header .btn-hamburger').removeClass('open');
		$('.main-header .btn-hamburger').next().removeClass('active');
		$('.main-header .mega-menu-background').removeClass('active');
		$('body').removeClass('lock-scroll overlayed');
	}
	static closeNextStep() {
		$('.next-step-btn').find('.next-step-btn').parent().removeClass('open');
		$('.main-header .mega-menu-background').removeClass('active');
		$('body').removeClass('lock-scroll overlayed');
	}

	hideAllMenus(e) {
		const clickables = [
			...$('.main-header .main-header__mobile'),
			...$('.main-header .main-header__desktop .main-header-bottom__nav-wrp'),
			...$('.main-header .btn-hamburger'),
			...$('.main-header .btn-search'),
			...$('.main-header .search-wrapper'),
			...$('.main-header .next-step-btn .menu'),
		];

		let isClickable = false;

		for (const clickable of clickables) {
			if ($(e.target).is(clickable) || $(e.target).closest(clickable).length > 0) {
				isClickable = true;
				break;
			}
		}
		
		if (!isClickable) {
			MegaMenu.closeSearch();
			MegaMenu.closeNextStep();
			MegaMenu.closeHamburger();
			MegaMenu.closeAllMegaMenus();
		}
	}
	toggleNextStep(e) {
		if (!$(e.currentTarget).hasClass('next-step')) {
			e.preventDefault();
		}

		MegaMenu.closeSearch();
		MegaMenu.closeAllMegaMenus();

		// TOGGLES NEXT STEP MENU
		if ($(this).closest('.menu-item').hasClass('open')) {
			$(this).closest('.menu-item').removeClass('open');
			$(this).parent().find('ul a').attr('aria-expanded', 'false');
			$(this).parent().find('ul a').attr('tabindex', '-1');
		} else {
			$(this).closest('.menu-item').addClass('open');
			$(this).parent().find('ul a').attr('aria-expanded', 'true');
			$(this).parent().find('ul a').attr('tabindex', '0');
		}
	}
	toggleHamburger(e) {
		e.preventDefault();
		MegaMenu.closeSearch();
		MegaMenu.closeAllMegaMenus();

		// TOGGLES HAMBURGER MENU
    if ($(this).hasClass('open')) {
      $(this).removeClass('open');
      $(this).next().removeClass('active');
    } else {
      $(this).addClass('open');
      $(this).next().addClass('active');
			$('.main-header .mega-menu-background').addClass('active');
			$('body').addClass('lock-scroll overlayed');
    }
	}
	toggleMegaMenu(e) {
		e.preventDefault();
		// ANIMATION SIMULATING ASANA
		// checkOpenLinkPosition($(this));

		// CHECKING FOR RESOLUTION TO REMOVE OVERLAY
		if (matchMedia('(min-width: 1200px)').matches) {
			MegaMenu.closeSearch();
			MegaMenu.closeNextStep();
			MegaMenu.closeHamburger();
		} else {
			$('.main-header .search-wrapper').removeClass('active');
			$('.main-header .btn-search').removeClass('open');
			$('.next-step-btn').find('.next-step-btn').parent().removeClass('open');
		}

		// TOGGLES MEGA MENU
		if ($(this).parent().hasClass('open-link') && $(this).closest('.main-header__nav').hasClass('open')) {
			$(this).closest('.main-header__nav').removeClass('open');
			$(this).next().removeClass('active');
			$(this).parent().removeClass('open-link');
			// MegaMenu.closeAllMegaMenus();
		} else {
			// CLOSES SIBLING MENUS
			$(this).parent().siblings().removeClass('open-link');
			$(this).parent().siblings().find('.mega-menu-wrapper').removeClass('active');

			// DELAY OPENING MEGA MENU FOR ANIMATION
			if (matchMedia('(min-width: 1200px)').matches) {
				const menuOpenDelay = setTimeout(() => {
					$(this).closest('.main-header__nav').addClass('open');
					clearTimeout(menuOpenDelay);
				}, 300);
			} else {
				$(this).closest('.main-header__nav').addClass('open');
			}

			// OPENING REST OF MEGA MENU ELEMENTS
			$(this).next().addClass('active');
			$(this).parent().addClass('open-link');
			$('.main-header .mega-menu-background').addClass('active');
			$('body').addClass('lock-scroll overlayed');
		}
	}
	toggleSearchBar(e) {
		e.preventDefault();
		MegaMenu.closeHamburger();
		MegaMenu.closeNextStep();
		MegaMenu.closeAllMegaMenus();

		// TOGGLES SEARCH BAR
		if (!$('.main-header .search-wrapper').hasClass('active')) {
			$('.main-header .search-wrapper').addClass('active');
			$('.main-header .mega-menu-background').addClass('active');
			$(this).addClass('open');
			$('body').addClass('search_bar_active lock-scroll overlayed');
		} else {
			$('.main-header .search-wrapper').removeClass('active');
			$('.main-header .mega-menu-background').removeClass('active');
			$(this).removeClass('open');
			$('body').removeClass('search_bar_active lock-scroll overlayed');
		}
	}
	bindEvents() {
		this.nextStepItem.parent().find('ul a').attr('tabindex', '-1');
		this.nextStepItem.parent().find('ul a').attr('aria-expanded', 'false');
		this.menuItemsLinks.on('click', this.toggleMegaMenu);
		this.hamburgerItem.on('click', this.toggleHamburger);
		this.searchItem.on('click', this.toggleSearchBar);
		this.nextStepItem.on('click', this.toggleNextStep);
		$(document).on("click", this.hideAllMenus);
	}
	resize() {
		if (!matchMedia('(min-width: 1200px)').matches) {
			// CHECKING IF THE HAMBURGER MENU IS OPEN AND CLOSES ALL MENUS IF NOT
			if (!$('.main-header .btn-hamburger').hasClass('open') && !$('.main-header .search-wrapper').hasClass('active')) {
				MegaMenu.closeAllMegaMenus();
			}
			if (!$('.main-header .search-wrapper').hasClass('active')) {
				MegaMenu.closeNextStep();
			}
		} else {
			// CHECKING IF THE HAMBURGER MENU IS NOT OPEN OR IF THE MEGA MENU IS NOT OPEN AND CLOSES MENUS IF NOT
			if (!$('.main-header .main-header__nav').hasClass('open') && !$('.main-header .search-wrapper').hasClass('active')) {
				MegaMenu.closeAllMegaMenus();
			}
			if ($('.main-header .btn-hamburger').hasClass('open') && !$('.main-header .search-wrapper').hasClass('active')) {
				MegaMenu.closeHamburger();
			}
		}
	}
	init() {
		this.bindEvents();
	}
}

export default new MegaMenu();
